// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U4qbduljS7wwZ470HNcw {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.U4qbduljS7wwZ470HNcw > div, .eJmPlhI2AqRbCDJqJIuC {
    width: 49%;
}

.cQ6BBjBHVpUSa14J9yYq {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
    .U4qbduljS7wwZ470HNcw {
        flex-direction: column;
    }

    .U4qbduljS7wwZ470HNcw > div, .eJmPlhI2AqRbCDJqJIuC {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Confirmation/ConfirmationPersonal/ConfirmationPersonal.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet from breakpoints;\n\n.row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.row > div, .half {\n    width: 49%;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    row-gap: 0.5rem;\n}\n\n@media screen and (max-width: tablet) {\n    .row {\n        flex-direction: column;\n    }\n\n    .row > div, .half {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"row": `U4qbduljS7wwZ470HNcw`,
	"half": `eJmPlhI2AqRbCDJqJIuC`,
	"form": `cQ6BBjBHVpUSa14J9yYq`
};
export default ___CSS_LOADER_EXPORT___;
